import { useCrane } from "@shared/context/CraneContext";
import Pagination from "@shared/components/Pages/ProductList/components/Pagination/Pagination.component";
import { ProductList_List } from "@shared/components/Pages/ProductList/components/List/List.component";
import { useTranslations } from "@shared/context/useTranslations";
import { IconNames } from "@shared/enums/icons.enums";
import { Icon } from "@shared/components/Molecules/Icon/Icon.component";
import { Breadcrumbs } from "@shared/components/Molecules/Breadcrumbs/Breadcrumbs.component";
import { useEffect, useState } from "react";
import { BreadcrumbItem } from "@shared/types/ContentTypes";
import S from "./CraneSearchResults.module.scss";

export const CraneSearchResults = () => {
    const {
        products,
        pageNumber,
        setPageNumber,
        setPageSize,
        error,
        categoryId,
        breadcrumbs,
        searchQuery,
    } = useCrane();
    const { getTranslation } = useTranslations();
    const [categoryBreadcrumbs, setCategoryBreadcrumbs] = useState<BreadcrumbItem[]>([]);

    const handlePages = (updatePage: number) => {
        setPageNumber(updatePage);
    };

    const handlePageSizeChange = (size: number) => {
        setPageSize(size);
        setPageNumber(1); //reset to page 1 when page size changes
    };

    useEffect(() => {
        if (breadcrumbs && categoryId && breadcrumbs[categoryId]) {
            setCategoryBreadcrumbs([...breadcrumbs[categoryId]].reverse());
        }
    }, [breadcrumbs, categoryId]);

    return (
        <div className={S.craneSearchResults}>
            {error ? (
                <div className={S.errorState}>
                    <Icon iconName={IconNames.Search} className={S.emptySearchIcon} />
                    <p className={S.emptyTitle}>{getTranslation("search.no-results")}</p>
                </div>
            ) : (
                <div className={S.productListWrapper}>
                    {products ? (
                        <>
                            {!searchQuery && categoryBreadcrumbs && (
                                <Breadcrumbs breadcrumbs={categoryBreadcrumbs} />
                            )}

                            <ProductList_List products={products || []} />
                            <Pagination
                                pageNumber={pageNumber}
                                pageSize={products?.pageSize || 0}
                                totalCount={products?.totalCount || 0}
                                totalPages={products?.totalPages || 0}
                                handlePagination={handlePages}
                                handlePageSizeChange={handlePageSizeChange}
                            />
                        </>
                    ) : null}
                </div>
            )}
        </div>
    );
};
